import '../../filter.scss'
import './filter-container-mobile.scss'

import { X as XIcon } from 'phosphor-react'
import React from 'react'
import IconButton from 'src/components/ui/IconButton'
import SlideOver from 'src/components/ui/SlideOver'
import type { IStoreSelectedFacet } from '@generated/graphql'
import type { SearchState } from '@faststore/sdk'
import { scrollToWithFiltered } from 'src/utils/scrollToWithFiltered'

import SelectedFilters from '../SelectedFilters'
import Facets from '../Facets'
import type { Callback } from '../../types/filterProps'
import type { FacetsProps } from '../../types/components/Facets'

interface FilterContainerMobileProps extends FacetsProps {
  onDismiss?: () => void
  isOpen?: boolean
  dismissTransition: React.MutableRefObject<Callback | undefined>
  setSelectedFacets: React.Dispatch<React.SetStateAction<IStoreSelectedFacet[]>>
  searchState?: SearchState
  filterNewTypeStatus?: boolean
  selectedFacetsFilter: IStoreSelectedFacet[]
  defaultFacets?: Array<{
    key: string
    value: string
  }>
  quiz?: boolean
}

function FilterContainerMobile({
  onDismiss,
  isOpen = false,
  testId = 'store-filter',
  dismissTransition,
  selectedFacets,
  setSelectedFacets,
  selectedFacetsFilter,
  searchState,
  cleanUpFacets,
  filteredFacets,
  indicesExpanded,
  onApply,
  onFacetChange,
  onAccordionChange,
  onAccordionItemMount,
  minPriceSelected,
  maxPriceSelected,
  setMinPriceSelected,
  setMaxPriceSelected,
  filterNewTypeStatus,
  defaultFacets,
  quiz,
}: FilterContainerMobileProps) {
  const dismissTransitionFunction = (callback: () => unknown) => {
    return () => {
      callback()
      scrollToWithFiltered(window?.location?.href, true)
    }
  }

  return (
    <SlideOver
      isOpen={isOpen}
      onDismiss={onDismiss}
      onDismissTransition={(callback) => {
        dismissTransition.current = dismissTransitionFunction(callback)
      }}
      size="partial"
      direction="rightSide"
      className="filter-modal__content"
    >
      <div className="filter-modal__body">
        <header className="filter-modal__header">
          <div className="filter-modal__header-title">
            <h2 className="title-display">Filtrar</h2>
            <button
              onClick={() => {
                dismissTransition?.current?.()
                cleanUpFacets?.()
              }}
            >
              Limpar todos
            </button>
          </div>
          <IconButton
            data-testid="filter-modal-button-close"
            classes="filter-modal__button"
            aria-label="Fechar filtros"
            icon={<XIcon size={32} />}
            onClick={() => {
              setSelectedFacets?.(
                filterNewTypeStatus && selectedFacets
                  ? selectedFacets
                  : searchState?.selectedFacets ?? []
              )
              dismissTransition.current?.()
            }}
          />
        </header>

        {selectedFacets?.length > 0 && (
          <SelectedFilters
            selectedFacets={selectedFacetsFilter}
            applyFilters={setSelectedFacets}
            defaultFacets={defaultFacets}
            quiz={quiz}
          />
        )}

        <Facets
          testId={`mobile-${testId}`}
          selectedFacets={selectedFacetsFilter}
          cleanUpFacets={cleanUpFacets}
          filteredFacets={filteredFacets}
          indicesExpanded={indicesExpanded}
          onFacetChange={onFacetChange}
          onAccordionChange={onAccordionChange}
          onApply={onApply}
          onAccordionItemMount={onAccordionItemMount}
          minPriceSelected={minPriceSelected}
          maxPriceSelected={maxPriceSelected}
          setMinPriceSelected={setMinPriceSelected}
          setMaxPriceSelected={setMaxPriceSelected}
          dismissTransition={dismissTransition}
        />
      </div>
    </SlideOver>
  )
}

export default FilterContainerMobile
